import { Button, Card, CardActions, CardContent, CardHeader, Divider, Table, TableBody, TableCell, TableRow } from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import capitalise from 'utils/capitalise';
import { StudentEdit } from './components';


const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: 0
  },
  actions: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    '& > * + *': {
      marginLeft: 0
    }
  },
  buttonIcon: {
    marginRight: theme.spacing(1)
  },
  header: {
    fontWeight: 600
  }
}));

const StudentInfo = props => {
  const { className, ...rest } = props;
  const model = useSelector(state => state.models.student);

  const classes = useStyles();

  const [openEdit, setOpenEdit] = useState(false);

  const handleEditOpen = () => {
    setOpenEdit(true);
  };

  const handleEditClose = () => {
    setOpenEdit(false);
  };

  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <CardHeader title="Student Info" />
      <Divider />
      <CardContent className={classes.content}>
        <Table>
          <TableBody>
            <TableRow>
              <TableCell className={classes.header}>Name</TableCell>
              <TableCell>{model.name_en}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.header}>Name (ZH)</TableCell>
              <TableCell>{model.name_zh}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.header}>Gender</TableCell>
              <TableCell>{capitalise(model.gender)}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.header}>Date of Birth</TableCell>
              <TableCell>{model.birthdate && moment(model.birthdate).format("DD/MM/YYYY")}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </CardContent>
      <CardActions className={classes.actions}>
        <Button onClick={handleEditOpen}>
          <EditIcon className={classes.buttonIcon} />
          Edit
        </Button>
      </CardActions>
      <StudentEdit onClose={handleEditClose} open={openEdit} />
    </Card>
  );
};

StudentInfo.propTypes = {
  className: PropTypes.string,
};

export default StudentInfo;
